<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="query"
            :filterable="filterable"
            :clearable="clearable"
            :label="label"
            :required="required"
            :selected-multiple="selectedMultiple"
            :multiple="multiple"
            :prop="prop"
            :name="name || prop"
            :disabled="disabled"
            :readonly="readonly"
            :key-id="keyId"
            :key-label="keyLabel"
            :key-tooltip="keyTooltip"
            :creatable="CCreatable"
            @change="handleChange"
            @create-new="createQuoteRequest" />
        <add-quote-request
            v-if="checkPermission(layoutPermissions['quote_request_add'])"
            ref="addQuoteRequest"
            @newQuoteRequest="handleChangeCreateQuoteRequest" />
    </div>
</template>

<script lang="ts" setup>
import AddQuoteRequest from '../../pages/trucker-[id]/quote/quote-request/-components/add.vue'
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  multiple: { type: Boolean, default: false },
  text: { type: String, default: '' },
  selectedMultiple: { type: [Array, Object], default: () => [] },
  required: { type: Boolean, default: false },
  name: { type: String, default: 'quoteRequest' },
  prop: { type: String, default: 'quoteRequest' },
  label: { type: String, default: () => $t('labels.quoteRequest') },
  filterable: { type: Boolean, default: true },
  clearable: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  creatable: { type: Boolean, default: false },
  keyTooltip: { type: String },
  keyId: { type: String, default: '_id' },
  keyLabel: { type: String, default: 'code' },
  type: { type: String, default: '' }
})

const emits = defineEmits(['update:modelValue', 'update:text', 'click', 'change'])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const { modelValue, name, required, multiple, text, type, creatable } = toRefs(props)

const CCreatable = computed(() => {
  if (!creatable?.value) {
    return false
  }
  if (!checkPermission(layoutPermissions.quote_request_add)) {
    return false
  }
  return true
})

const addQuoteRequest = ref()

const createQuoteRequest = () => {
  if (!creatable?.value) {
    return null
  }

  if (!checkPermission(layoutPermissions.partner_add)) {
    process.client && $toast().error($t('labels.vendorPriceModule.notPermission'))
    return null
  }
  addQuoteRequest.value.open()
}

const query = async (s: string) => {
  const api: any = $url.quote.quoteRequest.find

  const res = await $api(api, { uriParams: { KEY: s } })
  const resData: any = res?.data?.value
  if (resData?.success) {
    return resData.data
  }
  return []
}

const cText = computed({
  get () {
    return text.value || ''
  },
  set (val: any) {
    emits('update:text', val)
  }
})
const information = ref([])

const handleChange = (val: any) => {
  information.value = val
  emits('change', val)
}

const handleChangeCreateQuoteRequest = (data: any) => {
  if (!multiple.value) {
    if (data && data._id) {
      cValue.value = data._id || ''
    }
    emits('change', [data])
  }
}
</script>
